"use client";
import React from "react";
import Error500 from "../src/components/Error500/Error500";

// Component for handling global errors in the application
const error = ({ error }) => {
  // Explicitly log the error details
  console.log("Error caught in global-error.js:", {
    message: error.message,
    stack: error.stack,
    digest: error.digest, // Available for app router errors
    url: window.location.href,
  });

  return <Error500 error={error} />;
};

export default error;
